var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "summary-accordion-container" }, [
    _c(
      "ul",
      {
        staticClass: "accordion summary-accordion accordion-customize",
        attrs: {
          id: "recent-addendum-summary-accordion",
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-multi-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
        },
      },
      [
        _c(
          "li",
          {
            staticClass: "accordion-item",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c(
              "a",
              {
                staticClass: "accordion-title",
                attrs: { href: "#addendum-summary-accordion-0" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("summary.name")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: {
                  id: "addendum-summary-accordion-0",
                  "data-tab-content": "",
                },
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "accordion",
                    attrs: {
                      id: "recent-addendum-accordion",
                      "data-accordion": "",
                      "data-deep-link": "true",
                      "data-allow-all-closed": "true",
                      "data-multi-expand": "true",
                      "data-update-history": "true",
                      "data-deep-link-smudge": "500",
                    },
                  },
                  _vm._l(_vm.filteredAddendums, function (revision, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "accordion-item",
                        class: { "is-active": index === 0 },
                        attrs: { "data-accordion-item": "" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "accordion-title",
                            attrs: { href: "#addendum-accordion-" + index },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("summary.location.addendum")) +
                                " " +
                                _vm._s(revision.version) +
                                "\n              "
                            ),
                            _vm.isPicView
                              ? _c("i", {
                                  staticClass:
                                    "fa fa-pencil fa-lg icon accordion-title-edit-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.editComment(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            revision.commentUpdatedBy &&
                            revision.commentUpdatedAt
                              ? _c("span", { staticClass: "edit-history" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("lastUpdatedBy", [
                                          revision.commentUpdatedBy,
                                          _vm.dateUtil.format(
                                            revision.commentUpdatedAt,
                                            _vm.dateUtil.DD_MMM_YY_HH_MM
                                          ),
                                        ])
                                      ) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.showEditArea(index)
                              ? _c("p", { staticClass: "accordion-comment" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(revision.comment) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                  },
                                  keydown: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm.showEditArea(index)
                                  ? _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: revision.comment,
                                          expression: "revision.comment",
                                        },
                                      ],
                                      ref: "edit-comment-area-" + index,
                                      refInFor: true,
                                      attrs: {
                                        rows: "3",
                                        placeholder: _vm.$t(
                                          "summary.addendumComment"
                                        ),
                                      },
                                      domProps: { value: revision.comment },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.saveComment(revision)
                                        },
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            revision,
                                            "comment",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "accordion-content",
                            attrs: {
                              id: "addendum-accordion-" + index,
                              "data-tab-content": "",
                            },
                          },
                          [
                            _c("addendum-item", {
                              attrs: { addendums: revision.addendum },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._t("vendor-bid-status"),
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }